import TabaccoLanding from './TabaccoModule';

export default TabaccoLanding;
